// extracted by mini-css-extract-plugin
export default {"container":"hawk-inbody-container","heading":"hawk-inbody-heading"};